export function getCurrentPageIdentifier(appExtensionSdkData) {
  return appExtensionSdkData?.pageIdentifier;
}
